export default "__VITE_ASSET__k43nuLLJ__"